"use client";

import styles from "./Button.module.scss";
import classNames from "classnames";
import { ButtonTypes } from "./Button.types";

const Button = ({
  size = "large",
  variant = "primary",
  type = "default",
  children,
  className = "",
  href,
  onClick = () => {},
  openInNewTab = false,
  disabled = false,
  loading = false,
}: ButtonTypes) => {
  const classNameResolved = classNames(
    styles["button"],
    styles[`button--${variant}`],
    styles[`button--${size}`],
    disabled && styles[`button--disabled`],
    type === "text" && styles[`button--text`],
    className,
  );

  const trimmedHref = href?.trim() ?? "";
  const isLink = trimmedHref.length > 0;

  if (isLink) {
    return (
      <a
        href={trimmedHref}
        {...(openInNewTab
          ? { target: "_blank", rel: "noopener noreferrer" }
          : {})}
        onClick={onClick}
        aria-disabled={disabled || undefined}
        className={classNameResolved}
      >
        {children}
        {loading && <div className={styles["button__loading"]} />}
      </a>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={classNameResolved}
    >
      {children}
      {loading && <div className={styles["button__loading"]} />}
    </button>
  );
};

export { Button };
export default Button;
